import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { InputAdornment, Input, IconButton } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: '4px',
    alignItems: 'center',
    padding: theme.spacing(1),
    display: 'flex',
    flexBasis: 420,
    backgroundColor: '#f1f1f1'
  },
  icon: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary
  },
  input: {
    flexGrow: 1,
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '-0.05px'
  },
  clearIcon: {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
}));

const SearchInput = props => {
  const { className, onChange, style, value, onClear, ...rest } = props;

  const classes = useStyles();

  return (
    <div {...rest} className={clsx(classes.root, className)} style={style}>
      <SearchIcon className={classes.icon} />
      <Input
        {...rest}
        value={value}
        className={classes.input}
        disableUnderline
        onChange={onChange}
        endAdornment={
          value.length > 0 && (
            <InputAdornment position="end">
              <IconButton
                variant="outlined"
                className={classes.clearIcon}
                disableRipple
                onClick={onClear}>
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          )
        }
      />
    </div>
  );
};

SearchInput.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object
};

export default SearchInput;
